import React, { useState, useEffect } from "react";
import TextEditor from "../components/TextEditor.jsx";
import "../static/css/AdminPublications.css";

const AdminPublications = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [date, setDate] = useState("");
  const [publicationContent, setPublicationContent] = useState("");
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [newCategoryImage, setNewCategoryImage] = useState(null);
  const [newCategoryDescription, setNewCategoryDescription] = useState("");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch("https://skpbackend.quindl.com/categories");
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const handleAddCategory = async () => {
    if (newCategory) {
      const categoryData = {
        name: newCategory,
        description: newCategoryDescription,
        image: newCategoryImage,
      };

      try {
        const response = await fetch("https://skpbackend.quindl.com/categories/add", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(categoryData),
        });

        if (response.ok) {
          const result = await response.json();
          alert("Category added successfully!");
          console.log(result);

          setNewCategory("");
          setNewCategoryImage(null);
          setNewCategoryDescription("");
          setCategories([...categories, result]);
        } else {
          alert("Failed to add category.");
        }
      } catch (error) {
        console.error("Error adding category:", error);
      }
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewCategoryImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async () => {
    const newPublication = {
      title,
      description,
      date,
      category_id: categoryId,
      content: publicationContent,
    };

    try {
      const response = await fetch("https://skpbackend.quindl.com/publications/add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newPublication),
      });

      if (response.ok) {
        const result = await response.json();
        alert("Publication posted successfully!");
        console.log(result);

        setTitle("");
        setDescription("");
        setDate("");
        setCategoryId("");
        setPublicationContent("");
      } else {
        alert("Failed to post publication.");
      }
    } catch (error) {
      console.error("Error posting publication:", error);
    }
  };

  return (
    <div className="admin-container">
      <div className="pub-content">
        <input
          type="text"
          placeholder="Article Title"
          className="article-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <textarea
          placeholder="Article Description"
          className="article-description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <select
          className="dropdown"
          value={categoryId}
          onChange={(e) => setCategoryId(e.target.value)}
        >
          <option value="">Select Category</option>
          {categories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>

        <div className="editor">
          <TextEditor
            content={publicationContent}
            setContent={setPublicationContent}
          />
        </div>

        <input
          type="date"
          className="publication-date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />

        <button className="post-button" onClick={handleSubmit}>
          POST Blog
        </button>
      </div>

      <div className="sidebar">
        <div className="add-category">
          <h4>Add a new category</h4>
          <input
            type="text"
            placeholder="Enter new category"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
          />
          <textarea
            placeholder="Enter category description"
            value={newCategoryDescription}
            onChange={(e) => setNewCategoryDescription(e.target.value)}
          />
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="category-image-upload"
          />
          {newCategoryImage && (
            <img
              src={newCategoryImage}
              alt="New Category Preview"
              className="category-image-preview"
            />
          )}
          <button className="add-button" onClick={handleAddCategory}>
            ADD CATEGORY
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminPublications;
